import { observer } from 'src/utils/mobx-react';
import {
    OverlayDefault,
    ContentSaferGambling,
    PopupDescriptionNoHeadline,
    AcceptBtn,
    LinkWrapper,
} from 'src/domains/players/webview/components/Account/Notifications/BlockingNotifications.style';
import React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { UniverseComponent } from 'src/domains/common/universes';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { useAsyncButtonAction } from 'src/domains/common/hooks/useAsyncButtonAction';

interface BlockingGamstopPreviouslyPositiveNotificationPropsType {
    onConfirm: () => Promise<void>;
}

export const BlockingGamstopPreviouslyPositiveNotification = observer(
    'BlockingGamstopPreviouslyPositiveNotification',
    ({ onConfirm }: BlockingGamstopPreviouslyPositiveNotificationPropsType): JSX.Element | null => {
        const common = useCommon();
        const router = StarRouter.get(common);
        const { accountHelperMail } = ConfigComponents.get(common).config;

        const { handleClick: handleAcknowledge, isLoading: isAcknowledgeLoading } = useAsyncButtonAction(async () => {
            await onConfirm();
            router.redirectTo({ account: 'static', static: 'safer-gambling' });
        });

        return (
            <OverlayDefault data-test='overlay-prompt'>
                <ContentSaferGambling>
                    <UniverseComponent>
                        {(universeModule): React.ReactElement => <universeModule.compliancePopupLogo />}
                    </UniverseComponent>

                    <PopupDescriptionNoHeadline data-test='account.blocking-popup.gamstop-previously-positive-description'>
                        <I18n
                            langKey='account.blocking-popup.gamstop-previously-positive.description-before-email'
                            defaultText='Our records show that you were previously registered with GAMSTOP. Your well-being is our priority, so we want to take a moment to ensure you are completely comfortable returning to gambling. If you feel uncomfortable with your activity, please see our Safer Gambling page or contact us at'
                        />
                        <LinkWrapper to={`mailto:${accountHelperMail}`}>
                            <I18n
                                langKey='account.blocking-popup.gamstop-previously-positive.description-email'
                                defaultText=' {accountHelperMail}'
                                params={{ accountHelperMail }}
                            />
                        </LinkWrapper>
                        <I18n
                            langKey='account.blocking-popup.gamstop-previously-positive.description-after-email'
                            defaultText=' for information on the tools and services available to you.'
                        />
                    </PopupDescriptionNoHeadline>

                    <AcceptBtn
                        onClick={handleAcknowledge}
                        size='medium'
                        isLoading={isAcknowledgeLoading}
                        disabled={isAcknowledgeLoading}
                    >
                        <I18n
                            langKey='account.blocking-popup.gamstop-previously-positive.confirm-button.label'
                            defaultText='Acknowledged'
                        />
                    </AcceptBtn>
                </ContentSaferGambling>
            </OverlayDefault>
        );
    }
);
